export const contactPreferredFields = [
  'cEmailAddress',
  'addressType',
  'physicalAddress',
  'postalAddress',
  'mPhoneNumber',
  'hPhoneNumber',
  'oPhoneNumber',
];

export const repContactMethodFields = [
  'repEmailAddress',
  'repPostalAddress',
  'repMPhoneNumber',
  'repHPhoneNumber',
  'repOPhoneNumber',
];
